/**
 * Type-specific TypeSpecificSection component for ahoy_deal.
 *
 * Renders the People list with the deal-flavoured section title
 * ("Associated contacts"). Mirror of CompanyPeopleSection — the section
 * title is the only difference. See company-people-section.tsx for the
 * design rationale.
 */

import type { CrmObject } from '@/types/crm';

import { PeopleSection } from './people-section';

export function DealPeopleSection({ object }: { object: CrmObject }) {
  return <PeopleSection object={object} sectionTitle='Associated contacts' />;
}
